import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  alertApiRef,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { toastApiRef } from '@backstage/frontend-plugin-api';

// ToastApi status -> AlertApi severity
const TOAST_STATUS_TO_SEVERITY = {
  neutral: 'info',
  info: 'info',
  success: 'success',
  warning: 'warning',
  danger: 'error',
} as const;

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // ToastApi (core.toast) shim for the legacy frontend system.
  // @backstage/plugin-notifications consomme toastApiRef (nouveau frontend
  // system), que @backstage/app-defaults (legacy) ne fournit pas -> crash au
  // chargement (NotImplementedError apiRef{core.toast}). On redirige les toasts
  // vers l'AlertApi pour que les notifications continuent de fonctionner.
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => ({
      post: toast => {
        const title = typeof toast.title === 'string' ? toast.title : '';
        const description =
          typeof toast.description === 'string' ? toast.description : '';
        alertApi.post({
          message:
            [title, description].filter(Boolean).join(' — ') || 'Notification',
          severity: TOAST_STATUS_TO_SEVERITY[toast.status ?? 'success'],
          display: 'transient',
        });
        return { close: () => {} };
      },
    }),
  }),
];
